import axios from "axios";
import merge from "lodash/merge";

export default {
  state: {},
  mutations: {},
  actions: {
    async api({ getters, dispatch }, conf) {
      const config = merge({}, getters.apiConf, conf);

      if (getters["auth/isSignIn"]) {
        await dispatch("auth/getIdToken");
      }

      return await axios(config);
    }
  },
  getters: {
    apiConf: (state, getters, rootState) => {
      const conf = {
        baseURL:"https://asia-northeast1-typt-82327.cloudfunctions.net/api",
          // process.env.NODE_ENV === "production"
          //   ? 
          //   : "http://localhost:5001/typt-82327/asia-northeast1/api",
        // "http://localhost:5000/api",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      };

      if (rootState.auth.auth) conf.headers.idtoken = rootState.auth.idToken;

      return conf;
    }
  }
};
